// extracted by mini-css-extract-plugin
export default {"main":"AIMarkingFooter_main__LwESe","rubrics":"AIMarkingFooter_rubrics__tPzho"};